import { useNavigate } from "react-router-dom";
import { Breadcrumb as RBBreadcrumb, Button } from "react-bootstrap";

const Breadcrumbs = (props: {
  Items: {
    title: string;
    url?: string;
  }[];
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="app-breadcrumb">
      <RBBreadcrumb className="app-breadcrumb__list ms-2 me-2 d-flex align-items-center">
        {props.Items.map((item, idx) => idx + 1 < props.Items.length ? (
          <RBBreadcrumb.Item
            className="app-breadcrumb__item"
            key={`BC-${idx}`}
            active={false}
          >
            {item.url ? (
              <Button
                type="button"
                variant="link"
                className="btn-nomin p-0 m-0 app-breadcrumb__link"
                onClick={() => { if (item.url) navigate(item.url); }}
              >
                {item.title}
              </Button>
            ) : item.title}
          </RBBreadcrumb.Item>
        ) : (
          <RBBreadcrumb.Item
            className="app-breadcrumb__item fw-bold"
            active={true}
            key={`BC-${idx}`}
          >
            {item.title}
          </RBBreadcrumb.Item>
        ))}
      </RBBreadcrumb>
    </div>
  );
};

export default Breadcrumbs;
